export const LANGUAGE_CHANNEL_NAME = 'language-channel';
export const TRADING_ACCOUNT_CHANNEL_NAME = 'trading-account-channel';
